function operatorToText(op) {
  switch (op) {
    case 'gte':
      return 'Greater than equal to';
    case 'lte':
      return 'Less than equal to';
    case 'between':
      return 'Between';
    default:
      return '';
  }
}

export default operatorToText;
